"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NaNDocs = void 0;
var NaNDocs = {
  name: 'NaN',
  category: 'Constants',
  syntax: ['NaN'],
  description: 'Not a number',
  examples: ['NaN', '0 / 0'],
  seealso: []
};
exports.NaNDocs = NaNDocs;